import { Box, CircularProgress, Typography } from '@mui/material';

import './LoadingTable.css';
import { LoadingTableProps } from './LoadingTable.types';

/**
 * LoadingTable Component
 *
 * Displays a full-screen loading state with spinner and message.
 * Used when loading table data or other large content sections.
 *

 * <LoadingTable message="Завантаження даних..." />
 */
export const LoadingTable = ({ message = 'Завантаження даних...' }: LoadingTableProps) => {
  return (
    <Box className="loading-table-container">
      <CircularProgress sx={{ color: 'rgb(132, 189, 0)' }} />
      <Typography>{message}</Typography>
    </Box>
  );
};
